import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  settings: {
    title: "",
    description: "",
    isPublic: true,
    isPrivate: false,
    category: 1,
    video: null,
    video_url: null,
  },
  coverPhoto: {},
  modalOpen: false,
  categories: [],
  duonutthumbnail_set: [],
  duonutToEdit: {}
};

// activity slice which the user is designing
const settings = createSlice({
  name: "settings",
  initialState,
  reducers: {
    updateTitle: (state, { payload }) => {
      state.settings.title = payload;
    },
    updateVideo: (state, { payload }) => {
      state.settings.video = payload.video;
      state.settings.video_url = null;
    },
    updateVideoUrl: (state, { payload }) => {
      state.settings.video_url = payload.video_url;
      state.settings.video = null;
    },
    updateDescription: (state, { payload }) => {
      state.settings.description = payload;
    },
    updateCategory: (state, { payload }) => {
      state.settings.category = payload.category;
    },
    updateCategories: (state, { payload }) => {
      state.categories = payload.categories;
    },
    toggleModal: (state, { payload }) => {
      state.modalOpen = !state.modalOpen;
    },
    updatePrivacy: (state, { payload }) => {
      return {
        ...state,
        settings: {
          ...state.settings,
          isPublic: !state.settings.isPublic,
          isPrivate: !state.settings.isPrivate,
        },
      };
    },
    updateSettings: (state, { payload }) => {
      state.settings = payload.settings;
    },
    updateDuonutThumbnailSet: (state, { payload }) => {
      state.duonutthumbnail_set = payload.thumbnails;
    },
    updateDuonutToEdit: (state, { payload }) => {
      state.duonutToEdit = payload.duonutToEdit;
    },
    updateCoverPhoto: (state, { payload }) => {
      state.coverPhoto = payload.coverPhoto;
    },
    setDuonutState: (state, { payload }) => {
      state.settings = payload.duonutSettings.settings;
      state.coverPhoto = payload.duonutSettings.coverPhoto;
      state.categories = payload.duonutSettings.categories;
    },
  },
});

export const { updateTitle, toggleModal, updateDescription,
  updateCategory, updateCategories,
  updatePrivacy, updateSettings,updateVideo,
  updateDuonutThumbnailSet, updateDuonutToEdit, updateCoverPhoto, setDuonutState, updateVideoUrl } = settings.actions;
export default settings.reducer;
